import { Component, Inject } from '@angular/core';
import { Storage, ref, getDownloadURL } from '@angular/fire/storage';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogTitle, MatDialogContent, MatDialogActions, MatDialogClose } from '@angular/material/dialog';
import { Observable, from } from 'rxjs';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatButton } from '@angular/material/button';
import { AsyncPipe } from '@angular/common';

export interface DialogData {
  title: string;
  helpVideoName: string;
}

@Component({
    selector: 'app-help-dialog',
    templateUrl: './help-dialog.component.html',
    styleUrls: ['./help-dialog.component.css'],
    imports: [MatDialogTitle, CdkScrollable, MatDialogContent, MatDialogActions, MatButton, MatDialogClose, AsyncPipe]
})
export class HelpDialogComponent {
  helpVideoUrl: Observable<string>;
  constructor(
    private storage: Storage,
    public dialogRef: MatDialogRef<HelpDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData
  ) {

    const storageRef = ref(this.storage, '_help/' + this.data.helpVideoName + '.mp4');
    this.helpVideoUrl = from(getDownloadURL(storageRef));
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

}